var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table"},[_vm._t("title"),_vm._t("head"),_vm._t("bar"),_vm._t("table"),_vm._t("pagination")],2)}
var staticRenderFns = []

export { render, staticRenderFns }